import React, { Component } from 'react';
import Feedback from '../../FeatureComponents/OverallFeedback/Feedback';
import { T } from '../../../../src/Components/FeatureComponents/Response/Utils';
import ModalPane from '../../FeatureComponents/ModalPane/ModalPane';

interface Props {
  handleModalToggle?: Function;
  submitFeedback: Function;
  showfeedback: boolean;
  botClosingModal: boolean;
}

class ClearSessionOverlay extends Component<Props, {}> {
  render() {
    return this.props.showfeedback ? (
      <Feedback
        submitFeedback={this.props.submitFeedback.bind(this)}
        handleModalToggle={this.props.handleModalToggle.bind(this)}
        skip={this.props.botClosingModal}
      />
    ) : (
      <ModalPane
        heading={<T labelName="chatExit" />}
        body={<T labelName="exitConfirmation" />}
        buttons={[
          {
            label: <T labelName="exitComponent" />,
            onClick: this.props.handleModalToggle.bind(this, true),
            variant: 'filled'
          },
          {
            label: <T labelName="continueChatLabel" />,
            onClick: this.props.handleModalToggle.bind(this),
            variant: 'filled'
          }
        ]}
        onClose={this.props.handleModalToggle.bind(this)}
        hideClose={true}
      />
    );
  }
}

export default ClearSessionOverlay;
